import type { FunctionComponent } from 'react';

import { Checkbox as FlowbiteCheckbox, Label } from 'flowbite-react';

import { labelVariants } from '../utils';
import type { CheckboxProps } from './types';

const customTheme = {
  root: {
    base: 'rounded border border-white shadow-[0_0_0_2px] shadow-brand border-3 ring-offset-0 focus:ring-offset-0 focus:ring-transparent focus:outline-none cursor-pointer disabled:cursor-not-allowed disabled:opacity-30',
    color: {
      default: 'shadow-n400_input_stroker checked:bg-n400_input_stroker checked:shadow-n400_input_stroker',
      primary: 'shadow-brand checked:bg-brand checked:shadow-brand dark:!shadow-brand dark:checked:!bg-brand dark:!shadow-brand',
      secondary: 'shadow-dark checked:bg-dark checked:shadow-dark'
    }
  }
};

const sizes = {
  small: 'w-4 h-4 ',
  medium: 'w-5 h-5 checked:bg-[length:0.75em_0.75em]',
  large: 'w-6 h-6 checked:bg-[length:1em_1em]'
};

export const Checkbox: FunctionComponent<CheckboxProps> = ({
  sizing = 'medium',
  labelStyle = 'normal',
  className,
  id,
  label,
  ...props
}) => {
  return (
    <div className={`flex items-center gap-2 mt-5 ${className}`}>
      <FlowbiteCheckbox {...props} theme={customTheme} className={sizes[sizing]} />
      {label && (
        <Label className={`text-base ${labelVariants[labelStyle]}`} htmlFor={id}>
          {label}
        </Label>
      )}
    </div>
  );
};
